export const containerCard = {
  '&.MuiPaper-elevation0': {
    backgroundColor: 'drawerNavigation.main',
    '&.MuiCard-root': {
      padding: '8px 0px 0px 0px',
      borderRadius: 0,
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },
    '& .MuiCardHeader-root': {
      display: 'flex',
      padding: '0px 16px',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    '& .MuiCardHeader-content': {
      display: 'flex',
      flex: 'none',
    },
    '& .MuiCardHeader-action': {
      margin: '0px',
      flex: 'none',
    },
  },
} as const;

export const headerDivider = {
  marginTop: '8px',
  marginBottom: '16px',
} as const;

export const containerFilter = {
  padding: '0px 16px 16px 16px',
} as const;
